/* ==========================================================================
   GoldenLove — cart upsell

   Adds an upsell product straight from the drawer and swaps the drawer for the
   freshly rendered one that comes back with the response.

   Delegated from `document` and loaded as a real asset rather than an inline
   script inside the snippet, for two reasons: cart.js replaces the innerHTML
   of `.drawer__inner` on every change, so any listener bound to an element in
   there dies on the first update; and a <script> injected through innerHTML
   never executes at all, so it would not rebind itself either.

   Asking for `sections: 'cart-drawer,cart-icon-bubble'` makes Shopify return
   the re-rendered markup with the add, so Dawn's own renderContents can put it
   straight in — one request, no reload, cart bubble included.
   ========================================================================== */

(function () {
  'use strict';

  var BUSY = 'aria-busy';

  function fail(root, btn, label, original, message) {
    btn.removeAttribute(BUSY);
    if (label) label.textContent = original;
    var box = root.querySelector('[data-upsell-error]');
    if (!box) return;
    box.textContent = message || 'Could not add that. Please try again.';
    box.hidden = false;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-upsell-add]');
    if (!btn || btn.hasAttribute(BUSY)) return;

    var root = btn.closest('[data-upsell]');
    var id = btn.getAttribute('data-variant-id');
    if (!root || !id) return;

    event.preventDefault();

    var label = btn.querySelector('[data-upsell-label]');
    var original = label ? label.textContent : '';
    btn.setAttribute(BUSY, 'true');
    if (label) label.textContent = 'Adding…';

    var box = root.querySelector('[data-upsell-error]');
    if (box) {
      box.hidden = true;
      box.textContent = '';
    }

    fetch(root.getAttribute('data-add-url') + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
      },
      body: JSON.stringify({
        items: [{ id: Number(id), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: root.getAttribute('data-sections-url') || window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        // Shopify reports a rejected add as 200 with a `status` field, not as
        // an HTTP error, so this has to be checked explicitly.
        if (data.status) {
          fail(root, btn, label, original, data.description || data.message);
          return;
        }

        var drawer = document.querySelector('cart-drawer');
        if (drawer && data.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data);
        } else {
          // No drawer to refresh — a reload at least leaves the cart correct.
          window.location.reload();
        }
      })
      .catch(function () {
        fail(root, btn, label, original);
      });
  });
})();
